/**
 * ConditionBuilder — Editor für DSL-condition oder early_return_if Expressions.
 * @since v2.514.0 (#1173)
 *
 * Props:
 *   - value: string (Mustache-Expression, z.B. "{{steps.classify.outputs.relevant}} == true")
 *   - onChange(value)
 *   - operators: CONDITION_OPERATORS
 *   - label: Anzeigetext
 */
export default function ConditionBuilder({ value = '', onChange, operators = [], label = 'Bedingung' }) {
  return (
    <div className="space-y-2">
      <div className="text-[10px] uppercase tracking-wide text-[var(--text-tertiary)] font-medium">{label}</div>
      <textarea
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        rows={2}
        placeholder='z.B. {{steps.classify.outputs.relevant}} == true'
        className="w-full px-2 py-1.5 border border-[var(--border-subtle,#E5E7EB)] rounded text-xs font-mono focus:outline-none focus:border-[#338edc]"
      />
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-[10px] text-[var(--text-tertiary)] mr-1">Operatoren:</span>
        {operators.map((op) => (
          <button
            key={op.op}
            type="button"
            onClick={() => onChange && onChange((value || '') + ` ${op.op} `)}
            className="px-1.5 py-0.5 text-[10px] font-mono border border-[var(--border-subtle,#E5E7EB)] rounded hover:bg-gray-50"
            title={op.label}
          >
            {op.op}
          </button>
        ))}
      </div>
    </div>
  );
}
